import Vue from 'vue';
import Vuex from 'vuex';
import state from "./state";
import * as actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: true,
  state,
  actions,
  mutations,
  getters
});

store.subscribe((mutation, state)=>{
  let type = mutation.type;
  switch(type){
    case "SET_TOKEN_NAME":
      sessionStorage.setItem("tokenName",JSON.stringify(state.tokenName));
      break;
    case "SET_TOKEN":
      sessionStorage.setItem("token",JSON.stringify(state.token));
      break;
    case "SET_LANG":
      localStorage.setItem("lang",JSON.stringify(state.lang));
      break;
    case "SET_USER_INFO":
      sessionStorage.setItem("userInfo",JSON.stringify(state.userInfo));
      break;
    case "SET_USER_ID":
      sessionStorage.setItem("id",JSON.stringify(state.id));
      break;
    case "SET_USER_TAGS":
      sessionStorage.setItem("userTags",JSON.stringify(state.userTags));
      break;
    case "SET_UNREAD_COUNT":
      sessionStorage.setItem("unreadCount",JSON.stringify(state.unreadCount));
      break;
    case "SET_SYSTEM_UNREAD_COUNT":
      sessionStorage.setItem("unreadSystemCount",JSON.stringify(state.unreadSystemCount));
      break;
    case "SET_CUSTOMER_UNREAD_COUNT":
      sessionStorage.setItem("unreadCustomerCount",JSON.stringify(state.unreadCustomerCount));
      break;
    case "SET_GROUPS_UNREAD_TOTAL_COUNT":
      sessionStorage.setItem("unreadGroupsTotalCount", JSON.stringify(state.unreadGroupsTotalCount));
      break;

    case "SET_COLLAPSE":
      sessionStorage.setItem("collapse",JSON.stringify(state.collapse));
      break;
    case "SET_EDITABLE_TABS":
      sessionStorage.setItem("editableTabs",JSON.stringify(state.editableTabs));
      break;
    case "SET_EDITABLE_TABS_VALUE":
      sessionStorage.setItem("editableTabsValue",JSON.stringify(state.editableTabsValue));
      break;
    case "SET_MENULISTS":
      sessionStorage.setItem("menuLists",JSON.stringify(state.menuLists));
      break;
    default:
      break;
  }
});

export default store;
